import { jsx as _jsx } from "react/jsx-runtime";
import DuplicateIcon from '@heroicons/react/outline/DuplicateIcon';
import { useClipboard } from 'use-clipboard-copy';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { CheckIcon } from '@tribeplatform/react-ui-kit/icons';
export const CodeCopyButton = ({ content }) => {
    const clipboard = useClipboard({ copiedTimeout: 1000 });
    return (_jsx(Button, { size: "xs", variant: "secondary", leadingIcon: clipboard.copied ? _jsx(CheckIcon, {}, void 0) : _jsx(DuplicateIcon, {}, void 0), className: "absolute top-2 right-2 opacity-0 transition-opacity code-copy-button", onClick: () => clipboard.copy(content), children: clipboard.copied ? 'Copied' : 'Copy' }, void 0));
};
//# sourceMappingURL=CodeCopyButton.js.map